import { useMemo, useState } from "react"

import { OrderSortField, SortingOrder } from "@/graphql/codegen/graphql"
import {
  Categories,
  type SortableOrderLineAccessorKey,
  type SortablePurchaseOrderAccessorKey,
  orderSortFieldToOrderLineAccessoryKey,
  orderSortFieldToPurchaseOrderAccessoryKey,
} from "@/screens/Procurement/PurchaseOrders/types"

interface UsePurchaseOrderTableProps {
  sortBy?: OrderSortField
  sortOrder?: SortingOrder
  category?: string
}

interface UsePurchaseOrderTableReturn {
  sorting: { id: SortablePurchaseOrderAccessorKey | SortableOrderLineAccessorKey; desc: boolean }[]
  expanded: Record<string, boolean>
  selected: Record<string, boolean>
  setExpanded: (expanded: Record<string, boolean>) => void
  setSelected: (selected: Record<string, boolean>) => void
}

export const usePurchaseOrderTable = ({
  sortBy = OrderSortField.UpdatedOn,
  sortOrder = SortingOrder.Asc,
  category,
}: UsePurchaseOrderTableProps): UsePurchaseOrderTableReturn => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})
  const [selected, setSelected] = useState<Record<string, boolean>>({})

  const sorting = useMemo(() => {
    const sortField = sortBy
    let tableSortField
    if (category === Categories.Product) {
      tableSortField = orderSortFieldToOrderLineAccessoryKey.get(sortField)
    } else {
      tableSortField = orderSortFieldToPurchaseOrderAccessoryKey.get(sortField)
    }

    return [{ id: tableSortField, desc: sortOrder === SortingOrder.Desc }]
  }, [category, sortBy, sortOrder])

  return {
    sorting,
    expanded,
    selected,
    setExpanded,
    setSelected,
  }
}
